import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useAuth } from '../context/AuthContext'; // <-- use this for token
import API_URL from '../api/baseURL';

const OwnerChecklistViewer = () => {
  const { token } = useAuth(); // <-- get the token from context
  const [checklists, setChecklists] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchChecklists = async () => {
      try {
        const response = await axios.get(
          `${API_URL}/reception-checklists/owner/checklists`,
          {
            headers: { Authorization: `Bearer ${token}` }
          }
        );
        setChecklists(response.data);
      } catch (error) {
        console.error('❌ Failed to fetch checklists:', error);
      } finally {
        setLoading(false);
      }
    };

    if (token) fetchChecklists();
  }, [token]);

  if (loading) return <div className="p-6 text-center">Loading checklists...</div>;

  return (
    <div className="max-w-7xl mx-auto p-6 bg-[#17140F] shadow rounded overflow-auto">
      <h2 className="text-xl font-bold mb-4">📋 My Vehicle Reception Checklists</h2>

      {checklists.length === 0 ? (
        <p>No checklists available for your vehicles.</p>
      ) : (
        <table className="w-full table-auto border-collapse border border-[#2B2724] text-sm">
          <thead className="bg-[#1B1815]">
            <tr>
              <th className="border p-2">Date</th>
              <th className="border p-2">Vehicle</th>
              <th className="border p-2">Fuel Level</th>
              <th className="border p-2">Glass Broken</th>
              <th className="border p-2">Side Mirror</th>
              <th className="border p-2">Headlight</th>
              <th className="border p-2">Tire Bolt</th>
              <th className="border p-2">Tire Condition</th>
              <th className="border p-2">Odometer</th>
              <th className="border p-2">Warnings</th>
              <th className="border p-2">Scratches/Dents</th>
              <th className="border p-2">Customer Remarks</th>
              <th className="border p-2">Technician Comments</th>
            </tr>
          </thead>
          <tbody>
            {checklists.map((c) => (
              <tr key={c._id}>
                <td className="border p-2">{new Date(c.dateReceived || c.createdAt).toLocaleDateString()}</td>
                <td className="border p-2">
                  {c.vehicleId?.plateNumber || 'N/A'}<br />
                  {c.vehicleId?.brand} {c.vehicleId?.model}
                </td>
                <td className="border p-2">{c.fuelLevel}%</td>
                <td className="border p-2">{c.glassBroken ? 'Yes' : 'No'}</td>
                <td className="border p-2">{c.sideMirrorDamage ? 'Yes' : 'No'}</td>
                <td className="border p-2">{c.headlightDamage ? 'Yes' : 'No'}</td>
                <td className="border p-2">{c.tireBoltIssue ? 'Yes' : 'No'}</td>
                <td className="border p-2">{c.tireCondition}</td>
                <td className="border p-2">{c.odometer || '-'}</td>
                <td className="border p-2">{c.dashboardWarningLights || '-'}</td>
                <td className="border p-2">{c.scratchesOrDents || '-'}</td>
                <td className="border p-2">{c.customerRemarks || '-'}</td>
                <td className="border p-2">{c.technicianComments || '-'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default OwnerChecklistViewer;
